/**
 * Feature: Estoque
 * Módulos: Kit técnico
 */

export { default as KitTecnicoPage } from './components/KitTecnicoPage';

export const ESTOQUE_KIT_TECNICO_ROUTE = '/estoque/kit-tecnico';
export const ESTOQUE_ROUTES = [ESTOQUE_KIT_TECNICO_ROUTE];
